<template>
	<!-- 安全生产培训教育 -->
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item  v-if="bquery">
					<el-input v-model="filters.companyName" placeholder="企业名称"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input v-model="filters.trainName" placeholder="培训名称"></el-input>
				</el-form-item>
				<el-form-item >
					<el-button type="primary" v-on:click="getPageList">查询</el-button>
				</el-form-item>
				<el-form-item  v-if="!bquery">
					<el-button type="success" v-on:click="showAddRecord">上传培训记录</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="pagelist" highlight-current-row v-loading="listLoading"  style="width: 100%;">
			<el-table-column v-if="bquery" prop="coName" label="企业名称" min-width="200" align="center">
			</el-table-column>
			<el-table-column prop="trainName" label="培训名称" align="center" min-width="200">
			</el-table-column>			
      		<el-table-column prop="trainDate" label="培训时间" align="center" min-width="150">
			</el-table-column>
			<el-table-column prop="trainMember" label="参训人员" align="center"  min-width="200">
			</el-table-column>
      		<el-table-column prop="trainContent" label="培训内容" align="center"  min-width="200">
			</el-table-column>

			<el-table-column  label="操作" align="left" width="300">
				<template slot-scope="scope">					
					<el-button  v-if="!bquery" type="danger" size="small" @click="handleTrainDel(scope.$index, scope.row)">删除</el-button>
					<el-button  type="primary" size="small" @click="handleDownloadFile(scope.$index, scope.row)">下载培训附件</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="total,prev, pager, next" @current-change="handleCurrentChange" :page-size="20" :total="total" style="float:right;">
			</el-pagination>
		</el-col>

		<!--新增--> 

		<el-dialog title="新增培训记录" v-model="fileFormVisible" :close-on-click-modal="false" >
			<el-form :label-position="labelPosition" :model="fileForm" label-width="120px" :rules="fileFormRules" ref="fileForm">
				
				<el-form-item label="培训名称" prop="trainName">
					<el-input placeholder="请输入培训名称" v-model="fileForm.trainName" auto-complete="off"></el-input>
				</el-form-item>

				<el-form-item label="培训时间" prop="trainDate">
					<el-date-picker v-model="fileForm.selTrainDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" format="yyyy-MM-dd"></el-date-picker>
				</el-form-item>

				<el-form-item label="参训人员" prop="trainMember">
					<el-input placeholder="请输入参加培训的人员名单" v-model="fileForm.trainMember" auto-complete="off" type="textarea" :rows="2"></el-input>
				</el-form-item>

				<el-form-item label="培训内容" prop="trainContent">
					<el-input placeholder="请输入培训内容" v-model="fileForm.trainContent" auto-complete="off" type="textarea" :rows="2"></el-input>
				</el-form-item>

				<el-form-item label="培训附件" >
					<div>
						<input  ref="upLoadRef" type="file" @change.stop="handleFileUpload">
						<button  v-show="uploadstart" @click.stop.prevent="uploadTrainFile">上传</button>
					</div>
				</el-form-item>
				请提前准备好培训有关的文件，照片压缩成zip格式，压缩文件上传成功后，补充其他信息后点击保存。
			</el-form>
						
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="fileFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="handlefile" :loading="fileLoading">保存</el-button>
			</div>
		</el-dialog>
		

	</section>
</template>

<script>
	import axios from 'axios';
	import { companyTrainPageList,addCompanyTrain,deleteCompanyTrain} from '../../api/api';

	export default {
		data() {
			return {
				objectId:0, //当前登录的用户id，新增会用到
				coId:0, //当前登录的用户企业id

				bquery:false,//管理员权限


				filters: {
					companyName: '',
					trainName:''
				},
				pagelist: [],
				total: 0,
				page: 1,
				listLoading: false,

				//上传附件
				uploadstart:true,
				fcfile: null,

				//新增
				fileFormVisible: false, 
				fileLoading: false,
				fileFormRules: {
					trainName: [{ required: true, message: "请输入培训名称", trigger: "blur" }],
					trainMember: [{ required: true, message: "请输入参训人员", trigger: "blur" }],
					trainContent: [{ required: true, message: "请输入培训内容", trigger: "blur" }],
					trainDate: [{ required: true, message: "请选择培训时间", trigger: "blur" }],
				},
				
				fileForm: {
					createUserId:0,
					coId:0,

					trainName:"",
					trainMember:"",
					trainContent:"",   
					trainFileURL:"",   

					trainDate:"",
					selTrainDate:null,
				},
				
			}
		},
		methods: {
			handleDownloadFile: function (index, row) {
				if(row.correctFileURL!=""){
					let zipurl="https://aqjg.ycsyzglj.com/"+row.trainFileURL
					let a = document.createElement("a");//创建a标签
					a.setAttribute("href", zipurl);//设置文件下载地址
					a.setAttribute('target', '_blank');//在当前页面创建下载
					document.body.appendChild(a);//添加到body
					a.click();//触发事件
					document.body.removeChild(a);//移除标签
				}
			},
			handleFileUpload(event) {
				let filearr = event.target.files[0].name.split('.');

				if(filearr[1]=='zip'){
					this.fcfile = event.target.files[0];
				}else{
					this.fcfile = null;
					this.$message.error("请选择zip格式的文件");
				}
				
			},
			uploadTrainFile() {
				if(this.fcfile!=null){
					let formData = new FormData();
					formData.append('file', this.fcfile);
					formData.append('filetype', "Yhpczl");
					formData.append('secondarydir', "train_"+this.objectId);
					axios.post('/yhpczl/mgr/v1/uploadFile', formData, {
						headers: {
						'Content-Type': 'multipart/form-data'
						}
					}).then(response => {					
						if (response.data.code==0) {
							this.fileForm.trainFileURL = response.data.data.url;
							this.uploadstart=false
							this.$message.success("文件上传成功，请填写其他信息后点击保存");
						} else {
							this.$message.error("文件上传失败，请重新提交");
						}
					});
				}else{
					this.$message.error("请选择文件后再点击【上传】按钮");
				}
				
			},
		
			handleCurrentChange(val) {				
				this.page = val;
				this.getPageList();
			},
			//获取分页列表
			getPageList() {
				let para = {
					page: this.page,
					pageSize:20,
					coName: this.filters.companyName,
					coId:this.coId,
					objectId:this.objectId,
					trainName: this.filters.trainName
				};

				this.listLoading = true;

				companyTrainPageList(para).then((res) => {
					if(res.data.code==0){
						this.total = res.data.data.total;
						this.pagelist = res.data.data.list;
					}
					
					this.listLoading = false;

				});
			},
			
			
			
			showAddRecord: function (index, row) {
				this.fileFormVisible = true;

				this.fileForm.createUserId=this.objectId
				this.fileForm.coId=this.coId

				this.fileForm.trainName=""
				this.fileForm.trainMember=""
				this.fileForm.trainContent=""
				
				this.fileForm.trainDate=""
				this.fileForm.selTrainDate=null

				this.fileForm.trainFileURL=""
				this.fcfile = null;
				this.uploadstart=true
				if (this.$refs.upLoadRef) {
					this.$refs.upLoadRef.value = '' // 置空input文件
				}
			},
			handlefile: function () {
				if(this.fileForm.trainFileURL!=""){
					if(this.fileForm.selTrainDate!=null){
							this.fileForm.trainDate = this.fileForm.selTrainDate.toLocaleString();
					}
					// if (this.fileForm.trainDate!=null) {
						this.$refs.fileForm.validate((valid) => {
							if (valid) {
								this.$confirm('确认提交培训记录吗？', '提示', {}).then(() => {
								this.fileLoading = true;

								addCompanyTrain(this.fileForm).then((res) => {
										this.fileLoading = false;
										this.fileFormVisible = false;
										if(res.data.code==0){
											this.$message.success(res.data.message);
											this.getPageList();
										}
										else{
											this.$message.error(res.data.message);
										}
							

									});
								});
							}
						});
					// } else {
					// 	this.$message.error("请选择培训时间");
					// }
					
				}else{
					this.$message.error("请上传培训相关的资料（zip格式）");
				}			
			},	
			handleTrainDel: function (index, row) {
				this.$confirm('确认删除这条培训记录吗？', '提示', {}).then(() => {
					let deleteparam={
						trainId:row.trainId
					}
					deleteCompanyTrain(deleteparam).then((res) => {
						if(res.data.code==0){
							this.$message.success(res.data.message);
							this.getPageList();
						}
						else{
							this.$message.error(res.data.message);
						}
					});
				});	
			},
		},
		mounted() {			
			let user = JSON.parse(sessionStorage.getItem('user'));
			this.objectId = user.data.userId
			this.coId = user.data.coId

			if (user.data.roleId=="4") {
				this.filters.companyName = user.data.userName	
				this.bquery=false
			} else {
				this.bquery=true
			}

			this.getPageList();

		}
	}

</script>

<style scoped>
	
	
</style>


// WEBPACK FOOTER //
// enterpriseTrain.vue?e849a0b4